const Diff = require('diff');

function getTextChanged(oldText, newText) {
    let highlightsRed = [];
    let highlightsGreen = [];

    const diff = Diff.diffChars(oldText, newText);
    diff.forEach((part) => {
        if (part.removed) {
            highlightsRed.push([true, part.value]);
        } else if (part.added) {
            highlightsGreen.push([true, part.value]);
        } else {
            highlightsRed.push([false, part.value]);
            highlightsGreen.push([false, part.value]);
        }
    });

    const isTextChanged = !!highlightsRed.length || !!highlightsGreen.length;

    return [highlightsRed, highlightsGreen, isTextChanged];
}

function getHeadersChanged(oldHeader, newHeader) {
    const headerRed = { ...oldHeader };
    const headerGreen = { ...newHeader };
    let isHeadersChanged = false;

    if (oldHeader.name !== newHeader.name) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldHeader.name,
            newHeader.name
        );

        headerRed.highlights = highlightsRed;
        headerRed.isDeleted = true;

        headerGreen.highlights = highlightsGreen;
        headerGreen.isAdded = true;

        isHeadersChanged = true;
    }


    return [headerRed, headerGreen, isHeadersChanged];
}

function getPropsChanged(oldColumn, newColumn) {
    const propsRed = { ...oldColumn };
    const propsGreen = { ...newColumn };
    let isPropsChanged = false;

    // NAME
    if (oldColumn.name !== newColumn.name) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldColumn.name,
            newColumn.name
        );
        propsRed.nameHighlights = highlightsRed;
        propsRed.isDeleted = true;
        propsGreen.nameHighlights = highlightsGreen;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    // TYPE
    if (oldColumn.type !== newColumn.type) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldColumn.type,
            newColumn.type
        );
        propsRed.typeHighlights = highlightsRed;
        propsRed.isDeleted = true;
        propsGreen.typeHighlights = highlightsGreen;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    // PRIMARY KEY
    if (!!oldColumn.isPK !== !!newColumn.isPK) {
        propsRed.isPKChanged = true;
        propsGreen.isPKChanged = true;

        propsRed.isDeleted = true;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    // FOREIGN KEY
    if (!!oldColumn.isFK !== !!newColumn.isFK) {
        propsRed.isFKChanged = true;
        propsGreen.isFKChanged = true;

        propsRed.isDeleted = true;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    // NULLABLE
    if (!!oldColumn.isNN !== !!newColumn.isNN) {
        propsRed.isNNChanged = true;
        propsGreen.isNNChanged = true;

        propsRed.isDeleted = true;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    // INDEXES
    if (!!oldColumn.index?.type !== !!newColumn.index?.type) {
        propsRed.indexChanged = true;
        propsGreen.indexChanged = true;

        propsRed.isDeleted = true;
        propsGreen.isAdded = true;

        propsRed.isChanged = true;
        propsGreen.isChanged = true;
        isPropsChanged = true;
    }

    return [propsRed, propsGreen, isPropsChanged];
}
function getPropsDeleted(column) {
    let propsChanges = {
        ...column,
        nameHighlights: [[false, column.name]],
        typeHighlights: [[false, column.type]],
    };
    return propsChanges;
}
function getPropsAdded(column) {
    let propsChanges = {
        ...column,
        nameHighlights: [[false, column.name]],
        typeHighlights: [[false, column.type]],
    };
    return propsChanges;
}

function lcs(a, b) {
    const dp = Array(a.length + 1)
        .fill(null)
        .map(() => Array(b.length + 1).fill(0));

    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            if (a[i - 1] === b[j - 1]) {
                dp[i][j] = dp[i - 1][j - 1] + 1;
            } else {
                dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
            }
        }
    }

    let i = a.length;
    let j = b.length;
    const lcsResult = [];

    while (i > 0 && j > 0) {
        if (a[i - 1] === b[j - 1]) {
            lcsResult.unshift(a[i - 1]);
            i--;
            j--;
        } else if (dp[i - 1][j] > dp[i][j - 1]) {
            i--;
        } else {
            j--;
        }
    }

    return lcsResult;
}

function getColumnsOrder(oldKeys, newKeys) {
    const common = lcs(oldKeys, newKeys);
    let result = [];
    let oldIndex = 0;
    let newIndex = 0;

    for (let element of common) {
        while (oldIndex < oldKeys.length && oldKeys[oldIndex] !== element) {
            result.push(['del', oldKeys[oldIndex++]]);
        }
        while (newIndex < newKeys.length && newKeys[newIndex] !== element) {
            result.push(['add', newKeys[newIndex++]]);
        }
        result.push(['change', element]);
        oldIndex++;
        newIndex++;
    }

    while (oldIndex < oldKeys.length) {
        result.push(['del', oldKeys[oldIndex++]]);
    }

    while (newIndex < newKeys.length) {
        result.push(['add', newKeys[newIndex++]]);
    }

    return result;
}

// eslint-disable-next-line
function getColumnsChanged(oldTable, newTable) {
    const columnsChanges = {};
    let isColumnsChanged = false;


    const columnsOrder = getColumnsOrder(
        Object.keys(oldTable.value.columns),
        Object.keys(newTable.value.columns)
    );
    columnsOrder.forEach((columnOrder) => {
        const action = columnOrder[0];
        const columnKey = columnOrder[1];

        const oldColumn = oldTable.value.columns[columnKey];
        const newColumn = newTable.value.columns[columnKey];

        // if (oldTable?.value?.header?.name === 'bo.accounts') {
        //     console.log('getColumnsChanged ----', columnOrder, oldColumn, newColumn)
        // }

        switch (action) {
            case 'del': {
                const props = getPropsDeleted(oldColumn);
                columnsChanges[columnKey] = props;
                columnsChanges[columnKey].isDeleted = true;
                isColumnsChanged = true;
                break;
            }
            case 'add': {
                const props = getPropsAdded(newColumn);
                columnsChanges[columnKey] = props;
                columnsChanges[columnKey].isAdded = true;
                isColumnsChanged = true;
                break;
            }
            case 'change': {
                const [propsRed, propsGreen, isChanged] = getPropsChanged(
                    oldColumn,
                    newColumn
                );

                if (isChanged) {
                    columnsChanges[`${columnKey}_del`] = propsRed;
                    columnsChanges[`${columnKey}_add`] = propsGreen;
                    isColumnsChanged = true;
                } else {
                    columnsChanges[columnKey] = propsRed;
                }
                break;
            }
            default:
                break;
        }
    });


    return [columnsChanges, isColumnsChanged];
}

// function getColumnsChanged(oldTable, newTable) {
//     const columnsChanges = {};
//     let isColumnsChanged = false;

//     for (const key in newTable.columns) {
//         const oldColumn = oldTable.columns[key];
//         const newColumn = newTable.columns[key];
//         const columnName = key;

//         // column status: ADDED
//         if (!oldColumn) {
//             const [props, isAdded] = getPropsAdded(newColumn);
//             columnsChanges[columnName] = props;
//             columnsChanges[columnName].isAdded = isAdded;
//             isColumnsChanged = isColumnsChanged || isAdded;
//         }
//     }

//     for (const key in oldTable.columns) {
//         const oldColumn = oldTable.columns[key];
//         const newColumn = newTable.columns[key];
//         const columnName = key;

//         // column status: DELETED
//         if (!newColumn) {
//             const [props, isDeleted] = getPropsDeleted(oldColumn);
//             columnsChanges[columnName] = props;
//             columnsChanges[columnName].isDeleted = isDeleted;
//             isColumnsChanged = isColumnsChanged || isDeleted;

//             // column status: EXIST, CHANGED/NOT CHANGED
//         } else {
//             const [propsRed, propsGreen, isChanged] = getPropsChanged(oldColumn, newColumn);

//             if (isChanged) {
//                 columnsChanges[`${columnName}_del`] = propsRed;
//                 columnsChanges[`${columnName}_add`] = propsGreen;
//                 isColumnsChanged = true;
//             } else {
//                 columnsChanges[columnName] = propsRed;
//             }
//         }
//     }

//     return [columnsChanges, isColumnsChanged];
// }
function getColumnsDeleted(columns) {
    const columnsChanges = {};

    for (const id in columns) {
        const column = columns[id];
        const columnId = `${id}_del`;

        columnsChanges[columnId] = { ...column, isDeleted: true };
    }
    return [columnsChanges, true];
}
function getColumnsAdded(columns) {
    const columnsChanges = {};

    for (const id in columns) {
        const column = columns[id];
        const columnId = `${id}_add`;
        // const columnId = `${id}`;

        columnsChanges[columnId] = { ...column, isAdded: true };
    }
    return [columnsChanges, true];
}

export const getTablesChangesView = () => {
    const tablesChanges = {};

    return tablesChanges;
};

export const getElementsChangesView = (oldElements, newElements) => {
    const elementsChanges = {};

    for (const key in oldElements) {
        const oldElement = oldElements[key];
        const newElement = newElements[key];
        const elementId = key;

        if (oldElement.type !== 'table' && newElement.type !== 'table') {
            continue;
        }

        // element status: DELETED
        if (!newElement) {
            // set initial state
            elementsChanges[elementId] = {
                id: elementId,
                x: oldElement.x,
                y: oldElement.y,
                width: oldElement.width,
                height: oldElement.height,
                type: oldElement.type,

                value: {
                    columns: {},
                    headers: {
                        header_del: {
                            id: 'header_del',
                            name: oldElement.value.header.name,
                        },
                    },
                    header: { name: oldElement.value.header.name },

                    // headers: { header: { name: oldElement.headers.header.name } },
                    // name: oldElement.headers.header.name,
                },
                // columns: {},
                // headers: { header: { name: oldElement.headers.header.name } },
                // name: oldElement.headers.header.name,
            };

            const [columns, isDeleted] = getColumnsDeleted(
                oldElement.value.columns
            );
            elementsChanges[elementId].value.columns = columns;
            elementsChanges[elementId].value.isDeleted = isDeleted;

            // element status: EXIST, CHANGED/NOT CHANGED
        } else {

            // set initial state
            // elementsChanges[elementId] = { columns: {} };
            elementsChanges[elementId] = {
                id: elementId,
                x: newElement.x,
                y: newElement.y,
                width: newElement.width,
                height: newElement.height,
                type: newElement.type,

                value: {
                    columns: {},
                    headers: {},
                    header: { name: newElement.value.header.name },

                    // headers: {},
                    // name: newElement.headers.header.name,
                },
                // columns: {},
                // headers: {},
                // name: newElement.headers.header.name,
            };

            // === TABLE HEADERS
            // const [headersRed, headersGreen, isHeaderChanged] = getHeadersChanged(oldElement.value.header, oldElement.value.header);
            const [headersRed, headersGreen, isHeaderChanged] =
                getHeadersChanged(
                    oldElement.value.header.name === 'bo.accounts'
                        ? { name: 'bo.accounting' }
                        : oldElement.value.header,
                    oldElement.value.header
                );
            if (isHeaderChanged) {
                elementsChanges[elementId].value.headers.header_del =
                    headersRed;
                elementsChanges[elementId].value.headers.header_add =
                    headersGreen;
                elementsChanges[elementId].value.isHeaderChanged = true;
            } else {
                elementsChanges[elementId].value.headers.header = headersRed;
            }

            // === TABLE COLUMNS
            const [columns, isChanged] = getColumnsChanged(
                oldElement,
                newElement
            );
            elementsChanges[elementId].value.columns = columns;
            elementsChanges[elementId].value.isColumnsChanged = isChanged;

            if (isChanged) {
                console.log('columns', columns);
            }
        }
    }

    for (const key in newElements) {
        const oldElement = oldElements[key];
        const newElement = newElements[key];
        const elementId = key;

        if (oldElement?.type !== 'table' && newElement.type !== 'table') {
            continue;
        }

        // element status: ADDED
        if (!oldElement) {
            // set initial state
            elementsChanges[elementId] = {
                id: elementId,
                x: newElement.x,
                y: newElement.y,
                width: newElement.width,
                height: newElement.height,
                type: newElement.type,

                value: {
                    columns: {},
                    headers: {
                        header_add: {
                            id: 'header_add',
                            name: newElement.value.header.name,
                        },
                    },
                    header: { name: newElement.value.header.name },

                    // headers: { header: { name: newElement.value.header.name } },
                    // name: newElement.value.header.name,
                },
                // columns: {},
                // headers: { header: { name: newElement.headers.header.name } },
                // name: newElement.headers.header.name,
            };

            // elementsChanges[elementId] = { columns: {} };

            const [columns, isAdded] = getColumnsAdded(
                newElement.value.columns
            );
            elementsChanges[elementId].value.columns = columns;
            elementsChanges[elementId].value.isAdded = isAdded;

        }
    }

    return elementsChanges;
};
